import { render, staticRenderFns } from "./UseSvg.vue?vue&type=template&id=03425be8&lang=html&"
import script from "./UseSvg.vue?vue&type=script&lang=js&"
export * from "./UseSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "e68030fc"
  
)

export default component.exports